import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CheckCircle from '@material-ui/icons/CheckCircle';

const styles = {
  eventNoneButton: {
    padding: '1px',
    pointerEvents: 'none'
  },
  button: {
    padding: '1px',
    '&:disabled': {
      opacity: '0.5'
    }
  },
  iconColor: {
    color: 'green'
  }
};

const enhance = compose();

const button = enhance(
  ({ classes, id = null, onClickAction = null, disabled }) => {
    return (
      <Button
        disabled={disabled}
        className={onClickAction ? classes.button : classes.eventNoneButton}
        tabIndex={onClickAction ? '0' : '-1'}
        onClick={() => (id ? onClickAction(id) : onClickAction())}
      >
        <CheckCircle className={classes.iconColor} />
      </Button>
    );
  }
);

export default withRouter(withStyles(styles)(button));
